import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';
import { GroqImage } from '@/helpers/Image';
import { customRichTextComponent } from '@/sanity/sanityPortableText';
import { GROQImage } from '@/sanity/lib/definitions';

interface TuvSectionProps {
  data: {
    tuvText?: PortableTextBlock[];
    tuvImage?: GROQImage;
  };
}

export default function TuvSection({ data }: TuvSectionProps) {
  if (!data.tuvText && !data.tuvImage) return null;

  return (
    <section className="w-full flex justify-center px-[2rem] lg:px-0 bg-[#f4f5f5]">
      <div className="w-[min(141rem,100%)] bg-[#f1f1f1] border border-black/[0.05] rounded-[0.5rem] flex flex-col lg:flex-row items-start lg:items-center justify-between gap-[4.5rem] lg:gap-[2.5rem] px-[3rem] py-[3rem] lg:pl-[5rem] lg:pr-[2.5rem] lg:py-[2.75rem]">
        {data.tuvText && (
          <div className="richtext richtext-start lg:max-w-[64.75rem]">
            <PortableText
              value={data.tuvText}
              components={customRichTextComponent({
                block: {
                  h3: ({ children }) => (
                    <h3 className="mb-0 font-geist font-medium text-[2.75rem] lg:text-[3rem] leading-[1.15] tracking-[-0.1375rem] lg:tracking-[-0.15rem] text-black">
                      {children}
                    </h3>
                  ),
                },
              })}
            />
          </div>
        )}
        {data.tuvImage && (
          <GroqImage
            src={data.tuvImage.src}
            alt={data.tuvImage.name || ''}
            width={data.tuvImage.width}
            height={data.tuvImage.height}
            className="!w-full lg:!w-[37.5rem] !h-auto flex-shrink-0"
          />
        )}
      </div>
    </section>
  );
}
